/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Text, theme } from "@nordcloud/gnui";

export function getMessage(messageComponent: JSX.Element | string) {
  return typeof messageComponent === "string" ? (
    <Text css={{ fontWeight: theme.fontWeights.bold }} mb={0}>
      {messageComponent}
    </Text>
  ) : (
    messageComponent
  );
}
